import { useEffect, useRef } from "react";

/**
 * Code from: https://stackoverflow.com/a/66687839
 * by: dorsta & TarVK
 */

export function useHorizontalScroll() {
    const elRef = useRef<any>(undefined);
    useEffect(() => {
        const el = elRef.current;
        if (el) {
            const onWheel = (e: WheelEvent) => {
                if (e.deltaY === 0) return;
                if (
                    !(el.scrollLeft === 0 && e.deltaY < 0) &&
                    !(
                        el.scrollWidth -
                            el.clientWidth -
                            Math.round(el.scrollLeft) ===
                            0 && e.deltaY > 0
                    )
                ) {
                    e.preventDefault();
                }
                el.scrollBy(e.deltaY, 0);
            };
            el.addEventListener("wheel", onWheel);
            return () => el.removeEventListener("wheel", onWheel);
        }
    }, []);
    return elRef;
}
